import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentSection = ({ section, isExpanded, onToggle, documentId }) => {
  return (
    <div className="border-b border-border last:border-b-0">
      <button
        onClick={() => onToggle(documentId, section?.id)}
        className="w-full flex items-center justify-between p-4 hover:bg-muted/50 transition-colors text-left"
      >
        <div className="flex-1">
          <h4 className="font-semibold text-foreground mb-1">{section?.title}</h4>
          {!isExpanded && (
            <p className="text-sm text-muted-foreground line-clamp-1">
              {section?.content?.substring(0, 100)}...
            </p>
          )}
        </div>
        <Icon
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'}
          size={20}
          className="text-muted-foreground flex-shrink-0 ml-4"
        />
      </button>
      {isExpanded && (
        <div className="px-4 pb-4">
          <p className="text-foreground leading-relaxed whitespace-pre-line">
            {section?.content}
          </p>
        </div>
      )}
    </div>
  );
};

export default DocumentSection;